export default {
    noun: 'Noun',
    article: 'Article',
    adjective: 'Adjective',
    pronoun: 'Pronoun',
    verb: 'Verb',
    adverb: 'Adverb',
    preposition: 'Proposition',
    conjunction: 'Conjunction',
    interjection: 'Interjection',
    numeral: 'Number'
}
